import { render, staticRenderFns } from "./select-target.vue?vue&type=template&id=dddc966e&scoped=true"
import script from "./select-target.vue?vue&type=script&lang=js"
export * from "./select-target.vue?vue&type=script&lang=js"
import style0 from "./select-target.vue?vue&type=style&index=0&id=dddc966e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dddc966e",
  null
  
)

export default component.exports